import { NavLink } from "react-router-dom";
import { Home as HomeIcon, Sparkles, Trophy, Settings } from "lucide-react";

const items = [
  { to: "/", label: "Home",     icon: HomeIcon, testid: "nav-home-btn" },
  { to: "/world", label: "World", icon: Sparkles, testid: "nav-world-btn" },
  { to: "/progress", label: "Progress", icon: Trophy, testid: "nav-progress-btn" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 px-4 pt-2 pb-[max(10px,env(safe-area-inset-bottom))]"
    >
      <div
        className="max-w-md md:max-w-lg mx-auto flex items-center justify-between gap-1 px-2 py-1.5"
        style={{
          background: "hsla(0,0%,100%,0.85)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          borderRadius: "999px",
          boxShadow: "0 1px 0 rgba(255,255,255,0.7) inset, 0 20px 40px -20px hsla(258,20%,20%,0.25)",
        }}
      >
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testid}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 px-2 rounded-full text-[10px] font-semibold uppercase tracking-widest transition ${
                isActive
                  ? "bg-[hsl(var(--violet))] text-white shadow-[0_8px_20px_-10px_hsla(258,45%,48%,0.6)]"
                  : "text-[hsl(var(--ink-soft))] hover:text-[hsl(var(--ink))]"
              }`
            }
          >
            <Icon className="w-5 h-5" strokeWidth={2.2} />
            {label}
          </NavLink>
        ))}
        <NavLink
          to="/admin"
          data-testid="nav-admin-btn"
          className={({ isActive }) =>
            `w-10 h-10 flex items-center justify-center rounded-full ${
              isActive ? "bg-[hsl(var(--ink))] text-white" : "text-[hsl(var(--ink-mute))] hover:text-[hsl(var(--ink))]"
            }`
          }
          title="Parent"
          aria-label="Parent"
        >
          <Settings className="w-4 h-4" strokeWidth={2.2} />
        </NavLink>
      </div>
    </nav>
  );
}
